import { render, staticRenderFns } from "./HighlightsComponent.vue?vue&type=template&id=6efe1e62&scoped=true&"
import script from "./HighlightsComponent.vue?vue&type=script&lang=js&"
export * from "./HighlightsComponent.vue?vue&type=script&lang=js&"
import style0 from "./HighlightsComponent.vue?vue&type=style&index=0&id=6efe1e62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efe1e62",
  null
  
)

export default component.exports